import { attr, fk } from 'redux-orm'
import Base from './Base'

class Todo extends Base {
  static get fields() {
    return {
      id: attr(),
      title: attr(),
      completedAt: attr(),
      kind: attr(),
      createdAt: attr(),
      dossierId: fk({ to: 'dossier', as: 'dossier', relatedName: 'todos' }),
    }
  }
}

Todo.modelName = 'todo'

export default Todo
